import { render, staticRenderFns } from "./PageMyVehicleRepairList.vue?vue&type=template&id=8a0995ca"
import script from "./PageMyVehicleRepairList.vue?vue&type=script&lang=js"
export * from "./PageMyVehicleRepairList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports